import React, { useState } from "react";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { ArrowLeft, Save } from "react-feather";
import ToastNotification from "Components/UI/ToastNotification";
import { useSelector } from "react-redux";
import { loggedInUser } from "core/redux/slice/authSlice";
// import ClaimForm from "Components/Form/ClaimForm";
import { FormProvider, useForm } from "react-hook-form";
import { format } from "date-fns";
import { yupResolver } from "@hookform/resolvers/yup";
import { addClaimValidation } from "core/Operations/ValidationSchema/claimValidationSchema";
import Error404 from "MainPages/ErrorPages/error404";
import { all_routes } from "Router/all_routes";
import { Link, useNavigate } from "react-router-dom";
import { useInsertInsuranceTypeMutation } from "AppQuries/master/InsuranceType/insurancetype";
import { insuranceValidationSchema } from "core/Operations/ValidationSchema/MasterValidationSchema";
import InsuranceForm from "Components/Form/InsuranceForm";
import { toast } from "core/Operations/toast";
import { BackIcon } from "Components/UI/Icon/Icons";
const AddInsuranceType = () => {
  const userData = useSelector(loggedInUser);
  const {
    mutate: insertInsuranceType,
    isPending,
    isError,
    error,
  } = useInsertInsuranceTypeMutation();
  const methods = useForm({
    defaultValues: {
      companyCode: userData?.companyCode,
      code: 0,
      insuranceType: "",
      policyNo: "",
      insurancePeriod: "",
      startDate: "",
      endDate: "",
      sumInsured: 0,
      class: "",
      employeesList: "",
      purpose: "",
      abbreviation: "",
      responsibleBy: "",
      vendorName: "",
      agencyName: "",
      address: "",
      contactNo: "",
      emailID: "",
      activeSince: "",
      attachment: "",
      createUser: userData.userName,
      createDate: `${format(new Date(), "yyyy-MM-dd")}T${format(
        new Date(),
        "HH:mm:ss.SSS"
      )}Z`,
      modifyUser: userData.userName,
      modifyDate: `${format(new Date(), "yyyy-MM-dd")}T${format(
        new Date(),
        "HH:mm:ss.SSS"
      )}Z`,
      isActive: true,
    },
    resolver: yupResolver(insuranceValidationSchema),
  });

  const navigate = useNavigate();

  const {
    handleSubmit,
    formState: { errors },
  } = methods;
  console.log(errors);
  const onSubmit = (payload) => {
    insertInsuranceType(payload, {
      onSuccess: (data) => {
        if (data === true) {
          toast.success("Insurance Added Successfully.");
          setTimeout(() => {
            navigate(`${all_routes.master}${all_routes.insurancetype}`);
          }, 1000);
        } else {
          toast.warning(data?.[0]?.errorMessage || "Something went wrong.");
        }
      },
      onError: (error) => {
        toast.error(error.message || "Something went wrong.");
      },
    });
  };
  if (isError) return <Error404 error={error} />;
  return (
    <div>
      <div className="page-wrapper">
        <FormProvider {...methods}>
          <form onSubmit={handleSubmit(onSubmit)}>
            <div className="content">
              <div className="page-header">
                <div className="add-item d-flex">
                  <div className="page-title">
                    <h4>Add New Insurance</h4>
                    <h6>Add your new Insurance</h6>
                  </div>
                </div>

                <div className="page-btn">
                  <OverlayTrigger
                    placement="top"
                    overlay={
                      <Tooltip id="add-new-tooltip">Save Insurance</Tooltip>
                    }
                  >
                    <button type="submit" className="btn btn-added">
                      <Save className="me-2" />
                      Save
                    </button>
                  </OverlayTrigger>
                </div>
                <div className="page-btn">
                  <OverlayTrigger
                    placement="top"
                    overlay={<Tooltip id="add-new-tooltip">Back</Tooltip>}
                  >
                    <Link
                      to={`${all_routes.master}/${all_routes.insurancetype}`}
                      className="btn btn-secondary"
                    >
                      <BackIcon className="me-2" />
                      Back
                    </Link>
                  </OverlayTrigger>
                </div>
              </div>
              <div className="row">
                <div className="col-md-12">
                  <div className="card border-0">
                    <div className="card-header">
                      <h4 className="card-title">Add Insurance</h4>
                    </div>
                    <div className="card-body">
                      <InsuranceForm />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </form>
        </FormProvider>
      </div>
    </div>
  );
};

export default AddInsuranceType;
